import type { TEmpreendimentoBase } from '@/features/empreendimentos/shared/types/empreendimento'
import { HttpService } from '@/infra/http'

export class GetEmpreendimentoService extends HttpService {
  execute = async (idExterno: number) => {
    return this.http.get<TEmpreendimentoBase>(`api/v2/Empreendimento/${idExterno}`)
  }
}
